import React from 'react'
import { Box, Pagination as MuiPagination } from '@mui/material'

type Props = {
  itemsPerPage: number
  totalItems: number
  currentPage: number
  paginate: (pageNumber: number) => void
}

const Pagination: React.FC<Props> = ({ itemsPerPage, totalItems, currentPage, paginate }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const handleChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    paginate(page)
    window.scrollTo(0, 0)
  }

  return (
    <Box display="flex" justifyContent="center" marginTop={2}>
      <MuiPagination
        count={totalPages}
        page={currentPage}
        onChange={handleChange}
        color="primary"
        hidePrevButton
        hideNextButton
        variant="outlined"
      />
    </Box>
  )
}

export default Pagination
